module.exports = __webpack_public_path__ + "media/applicants/twitter-ef28f9a8.svg";